import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from 'react';
const initCardValues = {
    collapsed: false,
    collapsable: false,
    dataTest: 'card',
    editable: false,
    mode: undefined,
    useBackground: true,
    useRedesign: false,
};
export const CardContextObject = createContext(Object.assign({ registerCollapsed: () => { }, registerCollapsable: () => { }, registerDataTest: () => { }, registerEditable: () => { }, registerMode: () => { }, registerUseBackground: () => { }, registerUseRedesign: () => { } }, initCardValues));
export const CardContext = ({ children, collapsed: initCollapsed = initCardValues.collapsed, collapsable: initCollapsable = initCardValues.collapsable, dataTest: initDataTest = initCardValues.dataTest, editable: initEditable = initCardValues.editable, mode: initMode = initCardValues.mode, onModeChange, useBackground: initUseBackground = initCardValues.useBackground, useRedesign: initUseRedesign = initCardValues.useRedesign, }) => {
    const [collapsed, setCollapsed] = useState(initCollapsed);
    const [collapsable, setCollapsable] = useState(initCollapsable);
    const [dataTest, setDataTest] = useState(initDataTest);
    const [editable, setEditable] = useState(initEditable);
    const [mode, setMode] = useState(initMode);
    const [useBackground, setUseBackground] = useState(initUseBackground);
    const [useRedesign, setUseRedesign] = useState(initUseRedesign);
    const contextValueObject = {
        registerCollapsed: setCollapsed, // state
        registerCollapsable: setCollapsable, // actionable
        registerDataTest: setDataTest,
        registerEditable: setEditable,
        registerMode: setMode,
        registerUseBackground: setUseBackground,
        registerUseRedesign: setUseRedesign,
        collapsed,
        collapsable,
        dataTest,
        editable,
        mode,
        useBackground,
        useRedesign,
    };
    useEffect(() => {
        if (initMode !== mode) {
            setMode(initMode);
        }
    }, [initMode]);
    useEffect(() => {
        if (onModeChange && mode && mode !== 'loading')
            onModeChange(mode);
    }, [mode]);
    return (_jsx(CardContextObject.Provider, { value: contextValueObject, children: children }));
};
